<mat-spinner [diameter]="diameter" style="margin: 0 auto; top: 30vh"></mat-spinner>
